import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';
const Item = styled.li `
  ${setCssVar('accentColor', brand.hta.green)};
  ${setCssVar('bgColor', brand.greyLight)};
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('fgColorAlt', brand.black)};

  .theme-apl & {
    ${setCssVar('accentColor', brand.apl.green)};
    ${setCssVar('bgColor', brand.greyLight)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.black)};
  }

  .theme-hh & {
    ${setCssVar('accentColor', brand.white)};
    ${setCssVar('bgColor', brand.hortHouse.greyMid)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('fgColorAlt', brand.hortHouse.greyMid)};
  }

  .theme-rss & {
    ${setCssVar('accentColor', brand.rss.green)};
    ${setCssVar('bgColor', brand.greyLight)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('fgColorAlt', brand.white)};
  }

  display: block;
  cursor: pointer;
  flex: 0 1 auto;
  margin: 0;
  min-width: 0;
  padding: 0;

  @media ${until(Device.TabletLarge)} {
    margin-bottom: 3px;
  }
`;
const Link = styled.a `
  ${fonts.sourceSansPro.semiBold};
  position: relative;
  display: block;
  background: linear-gradient(to bottom, ${cssVar('accentColor')}, ${cssVar('accentColor')})
    no-repeat;
  background-size: 0% 100%;
  color: ${cssVar('fgColor')};
  font-size: 20px;
  line-height: 28px;
  margin: 0;
  overflow: hidden;
  padding: 17px 22px 17px;
  text-decoration: none;
  text-overflow: ellipsis;
  transition: background-color 0.15s ease-out, background-size 0.15s ease-out, color 0.15s ease-out;
  white-space: nowrap;

  &:focus,
  &:hover {
    background-size: 100% 100%;
    text-decoration: none;
    color: ${cssVar('fgColorAlt')};

    &::before {
      background-size: 100% 100%;
    }
  }

  ${({ isActive }) => isActive &&
    css `
      background-size: 100% 100%;
      text-decoration: none;
      color: ${cssVar('fgColorAlt')};

      &::before {
        background-size: 100% 100%;
      }
    `}

  ${({ centered }) => centered &&
    css `
      text-align: center;
    `}

  @media ${until(Device.TabletLarge)} {
    background: ${cssVar('bgColor')};
    padding-left: 10px;
    padding-right: 10px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 14px;
    padding: 15px 8px 15px;
  }

  @media ${from(Device.DesktopSmall)} {
    font-size: 16px;
    padding: 15px;
  }

  @media ${from(Device.DesktopMedium)} {
    font-size: 18px;
    padding: 17px 22px 17px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 20px;
  }
`;
export default {
    Item,
    Link,
};
